import { unstable_HistoryRouter as Router } from 'react-router-dom';
import { QueryClientProvider, QueryClient } from '@tanstack/react-query';
import ProjectRouters from './routers/router';
import { Toaster } from 'react-hot-toast';
import { ApolloProvider } from './apollo/ApolloProvider';
import RouteChangeHandler from '@/routers/RouteChangeHandler.ts';
import { history, useAppDispatch, loadAppSettingsRequested } from '@ax/redux-store';
import { useEffect, useRef } from 'react';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: Infinity,
      refetchOnWindowFocus: false,
    },
  },
});

function App() {
  const isInitialized = useRef(false);
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (!isInitialized.current) {
      dispatch(loadAppSettingsRequested());
      isInitialized.current = true;
    }
  }, [dispatch]);

  return (
    <>
      <ApolloProvider>
        <QueryClientProvider client={queryClient}>
          {/* @ts-expect-error* The history types in the router package are behind the history's package version. Still the object is perfectly compatible. */}
          <Router history={history}>
            <RouteChangeHandler />
            <ProjectRouters />
          </Router>
          <Toaster
            position="top-center"
            reverseOrder={false}
            toastOptions={{
              style: {
                maxWidth: 500,
              },
            }}
          />
        </QueryClientProvider>
      </ApolloProvider>
    </>
  );
}

export default App;
